import initialState from "./newCommunicationInitialState";
import {
    ADD_NEW_COMMUNICATION_POLL_OPTION,
    CLEAR_RECIPIENT_TYPE_SELECTION,
    DESELECT_CONTACTS,
    DISMISS_NEW_COMMUNICATION_ERROR_ALERT,
    FETCHING_CONTACTS_FROM_API,
    GET_AND_STORE_CONTACTS_FOR_LOCATIONS_SUCCESS,
    GET_COMMUNICATION_CONTACTS_SUCCESS,
    GET_COMMUNICATION_RECIPIENT_LOCATORS_FAIL,
    GET_COMMUNICATION_RECIPIENT_LOCATORS_SUCCESS,
    GET_CONTACTS_BY_GROUP_DATA_FAIL,
    GET_CONTACTS_BY_GROUP_DATA_SUCCESS,
    HANDLE_NEW_COMMUNICATION_POLL_OPTION_CHANGE,
    HANDLE_NEW_COMMUNICATION_TEXT_INPUT_CHANGE,
    POSTING_NEW_COMMUNICATION_TO_API,
    REMOVE_NEW_COMMUNICATION_POLL_OPTION,
    RESET_NEW_COMMUNICATION_STATE,
    SAVE_COMMUNICATION_DRAFT_FAIL,
    SAVE_COMMUNICATION_DRAFT_SUCCESS,
    STORE_SELECTED_CONTACTS,
    SEND_NEW_COMMUNICATION_FAIL,
    SEND_NEW_COMMUNICATION_SUCCESS,
    SUBMIT_NEW_COMMUNICATION_RECIPIENT_SELECTION,
    SUBMIT_RECIPIENT_TYPE_SELECTION,
    TOGGLE_NEW_COMMUNICATION_ADD_RECIPIENTS_MODAL,
    TOGGLE_POLL_INCLUSION,
    TOGGLE_REPLACE_RECIPIENTS_WARNING,
    TOGGLE_SELECTED_CONTACT,
    TOGGLE_VOICE_CALL_CHECKBOX,
    UPDATE_RECIPIENT_TYPE_SELECTION
} from "../../actions/communications/newCommunicationAction";
import _ from "lodash";
import isEmpty from "../../helpers/isEmpty";

export default function newCommunicationReducer(state = initialState.newCommunication, action) {

    switch (action.type) {

        case ADD_NEW_COMMUNICATION_POLL_OPTION: {
            let newPollOptions = state.pollOptions.slice();
            newPollOptions.push('');

            return {
                ...state,
                pollOptions: newPollOptions
            };
        }

        case CLEAR_RECIPIENT_TYPE_SELECTION: {
            return {
                ...state,
                addRecipientsBy: '',
                fetching: undefined,
                selectedRecipients: [],
                selectedRecipientType: '',
            };
        }

        case DESELECT_CONTACTS: {
            const updateSelected = state.availableContactLocations.map(contact => {
                return {...contact, isSelected: false};
            });

            return {
                ...state,
                availableContactLocations: updateSelected
            };
        }

        case DISMISS_NEW_COMMUNICATION_ERROR_ALERT: {
            return {
                ...state,
                showErrorAlert: false,
            };
        }

        case FETCHING_CONTACTS_FROM_API: {
            return {
                ...state,
                fetching: true
            };
        }

        case GET_COMMUNICATION_RECIPIENT_LOCATORS_SUCCESS: {
            const mappedContactLocations = mapContactLocations(action.contacts);
            return {
                ...state,
                availableContactLocations: mappedContactLocations,
                fetching: false
            };
        }

        case GET_COMMUNICATION_RECIPIENT_LOCATORS_FAIL: {
            return {
                ...state,
                showErrorAlert: true,
            };
        }

        case GET_COMMUNICATION_CONTACTS_SUCCESS: {
            return {
                ...state,
                availableContacts: action.contacts,
                fetching: false
            };
        }

        case GET_AND_STORE_CONTACTS_FOR_LOCATIONS_SUCCESS: {
            if (isEmpty(action.contacts)) {
                return {state};
            }
            const contactList = action.contacts.map(contact => {
                return {
                    id: contact.contactID,
                    location: contact.locationName,
                    contactType: 0,                               // Person
                    type: contact.contactTypeName,
                    locationId: contact.locationId,
                    displayName: contact.firstName + " " + contact.lastName,
                    addressInfo: contact.addressInfo,
                    organization: contact.organizationName
                };
            });

            const uniqueIds = new Set();
            const uniqueContacts = [...state.selectedRecipients, ...contactList].filter(item => {
                if (!uniqueIds.has(item.id)) {
                    uniqueIds.add(item.id);
                    return true;
                }
                return false;
            });


            return {
                ...state,
                fetching: false,
                selectedRecipients: uniqueContacts
            };
        }

        case STORE_SELECTED_CONTACTS: {
            if (isEmpty(action.contacts)) {
                return state;
            }
            const uniqueIds = new Set();

            const uniqueContacts = [...state.selectedRecipients, ...action.contacts].filter(item => {
                if (!uniqueIds.has(item.id)) {
                    uniqueIds.add(item.id);
                    return true;
                }
                return false;
            });

            return {
                ...state,
                selectedRecipients: uniqueContacts
            };
        }

        case GET_CONTACTS_BY_GROUP_DATA_FAIL: {
            return {
                ...state,
                showErrorAlert: true,
            };
        }

        case GET_CONTACTS_BY_GROUP_DATA_SUCCESS: {
            return {
                ...state,
                contactsByGroupData: action.contactData,
                fetching: false
            };
        }

        case HANDLE_NEW_COMMUNICATION_POLL_OPTION_CHANGE: {
            let newPollOptions = state.pollOptions.slice();
            newPollOptions[action.index] = action.value;

            return {
                ...state,
                pollOptions: newPollOptions
            };
        }

        case HANDLE_NEW_COMMUNICATION_TEXT_INPUT_CHANGE: {
            return {
                ...state,
                [action.name]: action.value
            };
        }

        case POSTING_NEW_COMMUNICATION_TO_API: {
            return {
                ...state,
                posting: true
            };
        }

        case REMOVE_NEW_COMMUNICATION_POLL_OPTION: {
            let newPollOptions = state.pollOptions.slice();
            _.pullAt(newPollOptions, action.index);

            return {
                ...state,
                pollOptions: newPollOptions
            };
        }

        case RESET_NEW_COMMUNICATION_STATE : {
            return initialState.newCommunication;
        }

        case SAVE_COMMUNICATION_DRAFT_FAIL: {
            return {
                ...state,
                showErrorAlert: true,
                posting: false
            };
        }

        case SAVE_COMMUNICATION_DRAFT_SUCCESS: {
            return {
                ...state,
                communicationDraftSuccessfullySaved: true,
                posting: false
            };
        }

        case SEND_NEW_COMMUNICATION_FAIL: {
            return {
                ...state,
                showErrorAlert: true,
                posting: false
            };
        }

        case SEND_NEW_COMMUNICATION_SUCCESS: {
            return {
                ...state,
                newCommunicationSuccessfullySent: true,
                posting: false
            };
        }

        case SUBMIT_NEW_COMMUNICATION_RECIPIENT_SELECTION: {
            return {
                ...state,
                selectedRecipients: action.recipients
            };
        }

        case SUBMIT_RECIPIENT_TYPE_SELECTION: {
            return {
                ...state,
                addRecipientsBy: state.selectedRecipientType,
            };
        }

        case TOGGLE_NEW_COMMUNICATION_ADD_RECIPIENTS_MODAL: {
            return {
                ...state,
                showAddRecipientsModal: !state.showAddRecipientsModal,
            };
        }

        case TOGGLE_POLL_INCLUSION: {
            return {
                ...state,
                includesPoll: !state.includesPoll,
            };
        }

        case TOGGLE_REPLACE_RECIPIENTS_WARNING: {
            return {
                ...state,
                showReplaceRecipientsWarning: !state.showReplaceRecipientsWarning,
            };
        }

        case TOGGLE_SELECTED_CONTACT: {
            const contactsSelectedIds = action.contactsSelected.map(z => z.id);
            const availableContactList = state.availableContactLocations.map(x => ({
                ...x,
                isSelected: contactsSelectedIds.includes(x.id)
            }));

            return {
                ...state,
                availableContactLocations: availableContactList
            };
        }

        case TOGGLE_VOICE_CALL_CHECKBOX: {
            return {
                ...state,
                sendVoiceCalls: !state.sendVoiceCalls,
            };
        }

        case UPDATE_RECIPIENT_TYPE_SELECTION: {
            return {
                ...state,
                selectedRecipientType: action.selectBy,
            };
        }

        default: {
            return state;
        }
    }
}

const mapContactLocations = contactList => {
    if (contactList === null || contactList === undefined) {
        return [];
    }

    const list = contactList.map(contact => {
        return {
            id: contact.id,
            isSelected: false,
            contactType: contact.contactType,
            location: contact.locationName,
            type: contact.typeName,
            latitude: contact.latitude,
            longitude: contact.longitude,
            locationId: contact.locationId,
            displayName: contact.displayName,
            addressInfo: contact.addressInfo,
            organization: contact.organizationName
        };
    });
    return list;
};




